<div class="plan-container">
	<mat-card>
		<mat-card-title>{{
			!projectId ? 'Crear proyecto' : 'Modificar proyecto'
		}}</mat-card-title>
		<mat-card-content>
			<div class="alert-info p1" *ngIf="hasDeliveries">
				Este proyecto no puede ser modificado porque ya tiene entregas
				relacionadas.
			</div>
			<form [formGroup]="frmProyecto" autocomplete="off">
				<div class="mt3">
					<div class="clearfix">
						<div class="col col-6 px2">
							<mat-form-field appearance="fill">
								<mat-label>Nombre</mat-label>
								<input formControlName="nombre" matInput />
							</mat-form-field>
						</div>
						<div class="col col-6 px2">
							<mat-form-field appearance="fill">
								<mat-label>Descripción</mat-label>
								<input formControlName="descripcion" matInput />
							</mat-form-field>
						</div>
					</div>
					<div class="clearfix">
						<div class="col col-6 px2">
							<mat-form-field appearance="fill">
								<mat-label>Tipo de financiación</mat-label>
								<mat-select formControlName="tipo_financiacion">
									<mat-option
										[value]="item.id"
										*ngFor="let item of list_tipo_financiacion"
										>{{ item.name }}</mat-option
									>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col col-6 px2">
							<mat-form-field appearance="fill">
								<mat-label>Tipo de proyecto</mat-label>
								<mat-select formControlName="tipo_proyecto">
									<mat-option
										[value]="item.id"
										*ngFor="let item of list_tipos_proyecto"
										>{{ item.name }}</mat-option
									>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>
			</form>
			<mat-divider></mat-divider>
			<div class="clearfix pl2 mt2">
				<span class="h3">Asignar recursos</span>
			</div>
			<div
				[formGroup]="formRecursos"
				*ngIf="resources.controls.length > 0; else noResources"
			>
				<ng-container formArrayName="recursos">
					<div
						[formGroupName]="i"
						*ngFor="let resour of resources.controls; let i = index"
						#resourceItem
					>
						<div>
							<div class="mt3">
								<div class="clearfix">
									<div class="col col-3 px2">
										<input type="hidden" hidden formControlName="id" />
										<app-resource-autocomplete
											formControlName="resource"
											[(resourcesList)]="resourcesList"
											[group]="getFormGroupByItem(i)"
											[allowResourceCreation]="true"
											[allowResourceEdition]="true"
										></app-resource-autocomplete>
										<div class="checkbox_container">
											<mat-checkbox formControlName="apply_serial">
												¿Requiere serial?
											</mat-checkbox>
										</div>
									</div>
									<div class="col col-2 px2">
										<mat-form-field appearance="fill">
											<mat-label>Cantidad</mat-label>
											<input
												autocomplete="off"
												formControlName="quantity"
												type="number"
												matInput
											/>
										</mat-form-field>
									</div>
									<div class="col col-4 px2">
										<mat-form-field appearance="fill">
											<mat-label>Comentarios</mat-label>
											<input
												autocomplete="off"
												matInput
												formControlName="observations"
											/>
											<!-- <textarea
												autocomplete="off"
												matInput
												formControlName="observations"
											></textarea> -->
										</mat-form-field>
									</div>
									<!-- <div class="col col-2 px2">
										<mat-checkbox formControlName="apply_serial">
											Aplica serial
										</mat-checkbox>
									</div> -->
									<div class="col col-1 px2 col-buttons">
										<button
											*ngIf="
												i === resources.controls.length - 1 && !hasDeliveries
											"
											(click)="addResourceButton()"
											mat-mini-fab
											color="primary"
											class="add-resource"
										>
											<mat-icon>add</mat-icon>
										</button>
										<button
											*ngIf="!hasDeliveries"
											mat-mini-fab
											color="danger"
											(click)="deleteResource(i)"
											tabindex="-1"
											class="delete-resource"
										>
											<mat-icon>delete</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<ng-template #noResources>
				<div class="p2">
					<div class="no-resources" (click)="addResourceButton()">
						Agrega recursos para el proyecto
					</div>
				</div>
			</ng-template>
			<div class="clearfix">
				<div class="left">
					<button
						mat-raised-button
						color="danger"
						class="mr1"
						routerLink="/recursos/proyectos/"
					>
						<mat-icon class="mr1">logout</mat-icon>
						<span>Cancelar</span>
					</button>
				</div>
				<div class="right">
					<button
						mat-raised-button
						color="primary"
						[disabled]="!(resources.controls.length > 0 && formRecursos.valid)"
						(click)="saveResources()"
						*ngIf="!hasDeliveries"
					>
						<mat-icon class="mr1">save</mat-icon>
						<span>Guardar</span>
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
